import GlobalStore from './global';
import CustomerQueueStore from './customer-queue';
import BusinessStore from './business';

export default {
  globalStore: new GlobalStore(),
  customerQueueStore: new CustomerQueueStore(),
  businessStore: new BusinessStore()
};